import { combineReducers } from '@reduxjs/toolkit';
import { withReduxStateSync } from 'redux-state-sync';

import Account from './account/reducer';
import Basket from './basket/reducer';
import Category from './category/reducer';
import Config from './config/reducer';
import Country from './country/reducer';
import Currency from './currency/reducer';
import EmailValidator from './email-validator/reducer';
import GiftRegistry from './gift-registry/reducer';
import GiftRegistryPublic from './gift-registry-public/reducer';
import Language from './language/reducer';
import Legal from './legal/reducer';
import MarketingPreference from './marketing-preference/reducer';
import Messenger from './messenger/reducer';
import Order from './order/reducer';
import Product from './product/reducer';
import ProductWatchdog from './product-watchdog/reducer';
import Products from './products/reducer';
import RequestFailed from './request-failed/reducer';
import Review from './review/reducer';
import Reviews from './reviews/reducer';
import Search from './search/reducer';
import Settings from './settings/reducer';
import User from './user/reducer';
import Withdrawal from './withdrawal/reducer';

const combinedReducers = combineReducers({
  Account,
  Basket,
  Category,
  Config,
  Country,
  Currency,
  EmailValidator,
  GiftRegistry,
  GiftRegistryPublic,
  Language,
  Legal,
  MarketingPreference,
  Messenger,
  Order,
  Product,
  ProductWatchdog,
  Products,
  RequestFailed,
  Review,
  Reviews,
  Search,
  Settings,
  User,
  Withdrawal,
});

const rootReducer = withReduxStateSync(combinedReducers);

export type RootState = ReturnType<typeof combinedReducers>;

export default rootReducer;
